import { transport } from 'config/transport';

export function callApiSaveGradeHolidays(gradeId, body) {
    return transport.post(`/mamnon/grades/${gradeId}/holidays`, body);
}
